module.exports = __webpack_public_path__ + "static/media/rain_drop.baf31691.gif";